/* eslint-disable react/prop-types */
import React, { useState } from 'react';

const Checklist = ({ children, onChange, className }) => {
  const [selected, setSelected] = useState([]);
  const deselect = (value) => {
    const currentSelection = [...selected];
    currentSelection.splice(selected.indexOf(value), 1);
    setSelected(currentSelection);
    onChange(currentSelection);
  };

  const select = (value) => {
    setSelected([...selected, value]);
    onChange([...selected, value]);
  };
  const _onSelected = (value) => {
    if (selected.includes(value)) {
      deselect(value);
    } else {
      select(value);
    }
  };
  return (
    <div className={className}>
      {children.map((child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            ...child.props,
            onSelected: _onSelected,
            isChecked: selected.includes(child.props.value),
          });
        }
        return <></>;
      })}
    </div>
  );
};

export default Checklist;
